/** One format policy for local files, explicit clipboard sources and saved native assets. */
export const nativeImageTypes = [
  "image/png",
  "image/jpeg",
  "image/webp",
  "image/gif",
  "image/svg+xml",
] as const;
const extensions: Record<string, string> = {
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  webp: "image/webp",
  gif: "image/gif",
  svg: "image/svg+xml",
};
export function imageMediaType(type: string, fileName = ""): string | null {
  const mime = type.split(";")[0]!.trim().toLowerCase();
  if ((nativeImageTypes as readonly string[]).includes(mime)) return mime;
  // Some file managers omit MIME. An explicit incompatible MIME is never overridden.
  return !mime || mime === "application/octet-stream"
    ? (extensions[fileName.split(".").at(-1)?.toLowerCase() ?? ""] ?? null)
    : null;
}
export function nativeImageSource(source: string): boolean {
  return /^data:image\/(png|jpeg|webp|gif|svg\+xml);base64,/i.test(source);
}
